import { createApiInstance } from './index';

const api = createApiInstance();

/**
 * 取得專案的掃描排程訂閱總覽
 * @param {string} projectUuid
 * @param {string} acctEmail
 */
export const getProjectScanSchedules = async (projectUuid, acctEmail) => {
  const response = await api.post('get_project_scan_schedules/', {
    project_uuid: projectUuid,
    acct_email: acctEmail,
  });
  return response.data;
};

/**
 * 修改單一掃描類型的訂閱週期／啟用狀態
 * 未帶的欄位維持原值
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string} payload.scan_type - CROWDSTRIKE | AZURE | GCP | AWS
 * @param {boolean} [payload.is_enabled]
 * @param {number} [payload.day_of_month] - 1-28
 * @param {number} [payload.hour] - 0-23
 * @param {number} [payload.minute] - 0-59
 * @param {string} payload.acct_email
 */
export const updateProjectScanSchedule = async (payload) => {
  const response = await api.post('update_project_scan_schedule/', payload);
  return response.data;
};

/**
 * 切換專案掃描主開關
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {boolean} payload.scan_enabled
 * @param {string} payload.acct_email
 */
export const updateProjectScanEnabled = async (payload) => {
  const response = await api.post('update_project_scan_enabled/', payload);
  return response.data;
};
